import * as React from 'react';
import { constants } from '../../constants/index';
import PText from 'components/Primatives/PText';
import FlexColumn from 'components/Primatives/FlexColumn';
import moment from 'moment-timezone';
import PercentBarChart from '../DataVisualization/PercentBarChart/PercentBarChart';
import { convertUtcToUserTimezone } from 'utils/timezoneUtils';
import { getActivePeriodTimestampsWithProgress } from 'utils/serviceUtils';



const ServiceProgress = (props) => {
    // console.log('activePeriods',props.activePeriods)
    // console.log('moment', moment.utc().format('x'))

    const activePeriodsInfo = getActivePeriodTimestampsWithProgress(props.activePeriods);

    const getActivePeriodProgressBar = (activePeriodsInfo) => (
        <div
            style={{
                display: 'flex',
                flexFlow: 'row wrap',
                alignItems: 'flex-start',
                width: '100%'
            }}
        >
            { activePeriodsInfo && activePeriodsInfo.length > 0 &&
                activePeriodsInfo.map(activePeriodInfo => {
                    if ((activePeriodInfo.activePeriodPercentage >= 0) && (activePeriodInfo.activePeriodPercentage < 100)){
                        return (
                            <FlexColumn id="Date&ProgressBar" style={{paddingRight: 15}}>
                                <React.Fragment>
                                    <PText altColor style={{ marginBottom: 5, fontSize: '1.4rem' }}>{activePeriodInfo.activePeriodPercentage.toFixed(0)}% Completed</PText>
                                    <PercentBarChart
                                        percentage={activePeriodInfo.activePeriodPercentage}
                                    />
                                </React.Fragment>
                            </FlexColumn>
                        )
                    }
                })
                    
            }
        </div>
    );

    const getActivePeriodServiceDuration = (activePeriodsInfo) => {
        let activePeriodCount = 0;
        { activePeriodsInfo && activePeriodsInfo.length > 0 &&
            activePeriodsInfo.map(activePeriodInfo => {
                if (activePeriodInfo.activePeriodPercentage < 100){
                    return activePeriodCount ++;
                }
            });
        }
        return (
            <React.Fragment>
                { activePeriodCount > 0 &&
                    <PText altColor style={{ marginBottom: 5, fontSize: '1.4rem' }}>Service Duration</PText>
                }
                <div
                    style={{
                        display: 'flex',
                        flexFlow: 'row wrap',
                        alignItems: 'flex-start',
                        width: '100%'
                    }}
                >
                    { activePeriodCount > 0 &&
                        activePeriodsInfo.map(activePeriodInfo => {
                            if (activePeriodInfo.activePeriodPercentage < 100){
                                const currentTz = moment.tz.guess();
                                const activePeriodStart = convertUtcToUserTimezone(activePeriodInfo.activePeriodStart)
                                const activePeriodEnd = convertUtcToUserTimezone(activePeriodInfo.activePeriodEnd)
                                
                                return (
                                    <PText altColor style={{marginBottom: 15, marginTop: 0, marginRight: 15, fontSize: '1.4rem', minWidth: 125}} >
                                        { moment(activePeriodStart, 'x').format('MMM Do') }
                                        { } – { } 
                                        { moment(activePeriodEnd, 'x').format('MMM Do') }
                                    </PText>
                                )
                            }
                        })
                            
                    }
            </div>
            </React.Fragment>
        )
    };



    // console.log('activePeriodsInfo', activePeriodsInfo)
    return (
        <div style={{ width:'100%' }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%'
                }}
            >

                {getActivePeriodProgressBar(activePeriodsInfo)}

                {getActivePeriodServiceDuration(activePeriodsInfo)}
               
            </div>
        </div>
    ); 
  };



  export default ServiceProgress;


// WEBPACK FOOTER //
// ./src/js/components/ServiceCardList/ServiceProgress.jsx